import Vue from 'vue'

const state = () => ({
    data: null,
})

const getters = {
}

const actions = {
}

const mutations = {
    addShareData (state, data) {
        state.data = data
    },
    removeShareData (state) {
        state.data = null
    }
}

export default {
  state,
  getters,
  actions,
  mutations
}